import styled from 'styled-components'
import { List } from 'antd'

interface WrapListItemProps {
  has_offline_offer: number
}

export const WrapListItem = styled(List.Item)<WrapListItemProps>`
  background-color: ${({ has_offline_offer }: WrapListItemProps) =>
    has_offline_offer ? '#cae4ff6b' : null};
  border-radius: 4px;
  border: 1px dashed rgb(232, 232, 232);
  padding: 12px;
`

export const OfflineOfferWarning = styled.span`
  font-size: small;
  font-weight: bold;
  color: #fd5836;
`
